package com.kinoshazam.screens.decide

import kotlinx.browser.window

actual fun currentWebOrigin(): String? = window.location.origin

actual fun consumeJoinUrlFromBrowser() {
    val path = window.location.pathname
    val search = window.location.search
    if (path.startsWith("/join/") || search.contains("join=")) {
        window.history.replaceState(null, "", "/")
    }
}
